exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NavLink__page___3jNgH {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21px;\n  opacity: 65%; }\n  .NavLink__page___3jNgH > a {\n    color: rgba(0, 0, 0, 0.5); }\n    .NavLink__page___3jNgH > a:hover {\n      color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"page": "NavLink__page___3jNgH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Footer/NavLink/NavLink.scss
// module id = 2087
// module chunks = 6